// extracted by mini-css-extract-plugin
export default {"logo":"App_logo__+IiLp","biggerSquareLogo":"App_biggerSquareLogo__UuoLm App_logo__+IiLp"};